import { tailwindBoxShadow as boxShadow, tailwindColors as colors, tailwindFlex as flex, tailwindFonts as fonts, tailwindPlugins as plugins, tailwindScreens as screens, tailwindSizes as sizes, tailwindTransforms as transforms, tailwindTransitions as transitions } from '@winelidays/wld-tsx-2/tailwind';
const config = {
    content: [
        './assets/react/**/*.{mjs,cjs,js,ts,jsx,tsx,mdx}',
        './templates/**/*.html.twig',
        './node_modules/@winelidays/**/*.{mjs,cjs,js,ts,jsx,tsx,mdx}',
        '../wld-tsx/**/*.{mjs,cjs,js,ts,jsx,tsx,mdx}', // for yarn linking the lib
        '!../wld-tsx/node_modules/*.{mjs,cjs,js,ts,jsx,tsx,mdx}' // for yarn linking the lib
    ],
    theme: {
        ...boxShadow,
        ...transforms,
        ...screens,
        extend: {
            ...fonts,
            ...sizes,
            ...transitions,
            ...colors,
            ...flex,
            outline: {
                primary: '2px solid #184D7B'
            },
            // default next13 init below
            backgroundImage: {
                'gradient-radial': 'radial-gradient(var(--tw-gradient-stops))',
                'gradient-conic': 'conic-gradient(from 180deg at 50% 50%, var(--tw-gradient-stops))'
            }
        }
    },
    plugins
};
export default config;
